import axios from "axios";
export default ({
  bypassAuthCheck = false,
  baseURL = "/rewaa_connector",
  headers,
  ...props
} = {}) => {
  const config = {
    baseURL,
    headers,
    ...props,
  };
  const client = axios.create(config);
  return client;
};
